import { Spinner, SpinnerProps } from '@chakra-ui/react';

function CircleLoader(props: SpinnerProps) {
  return (
    <Spinner
      data-testid="spinner"
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="blue.500"
      size="xl"
      {...props}
    />
  );
}

export default CircleLoader;
